const boxAccordionItemTheme = {
    baseStyle: {

    },
    variants: {
        lessonAccordionItem: {
            cursor: 'pointer',
            bgColor: 'gray.500',
            py: '1',
            px: '5',
            mt: '1',
            _hover: {
                bgColor: 'gray.600',
            }
        },
    },
    defaultProps: {
        variant: 'lessonAccordionItem'
    }
};

export default boxAccordionItemTheme;